import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'

import * as styles from './index.module.css'

const OsHero = ({ title, subtitle, images, mobileOnlyImages }) => {
  // assume the strategy is random if not fixed
  const isOS1 = title === 'OS1'
  const isOS2 = title === 'OS2'
  let sensorType = 'UNSPECIFIED'
  if (title === 'OS1') {
    sensorType = 'MID-RANGE LIDAR SENSOR'
  } else if (title === 'OS2') {
    sensorType = 'LONG-RANGE LIDAR SENSOR'
  }
  const isMobile = typeof window !== `undefined` && window.innerWidth <= 500
  const subtitleParts = subtitle.subtitle.split(';')
  const subtitleText = subtitleParts[0]
  const textColor = subtitleParts.length > 1 ? subtitleParts[1] : '#FFFFFF'
  let image = images[0]
  if (isMobile && mobileOnlyImages) {
    image = mobileOnlyImages[0]
  }
  return (
    <div className={styles.container}>
      <div>
        <GatsbyImage
          image={image.iphero}
          className={styles.heroImage}
          alt={image?.description}
        />
      </div>

      <div className={styles.details}>
        <h1 className={styles.label}>{sensorType}</h1>
        <div className="h1" style={{ color: textColor }}>
          {title}
        </div>

        <div
          className={`${styles.osTitle} ${styles.mobileOnly}`}
          style={{ color: textColor }}
        ></div>

        <div
          className={
            title === 'OS1'
              ? `${styles.body} ${styles.os1Body}`
              : `${styles.body} ${styles.os2Body}`
          }
          style={{ color: textColor }}
        >
          {subtitleText}
        </div>
      </div>

      <div
        className={`${styles.body} ${styles.mobileOnly}`}
        style={{ color: textColor }}
      >
        {subtitle.subtitle}
      </div>
    </div>
  )
}
export default OsHero
